module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-nicole.e48eed3c.jpg";